import {
  Box,
  FormattedMessage,
  Icon,
  IndicatorDotVariants,
  IndicatorDotWrapper,
  VStack,
  isOrderComplete,
  useObservableValue,
  useWLOrdersProvider,
} from '@talos/kyoko';
import { map } from 'rxjs';
import { MobileLabelMessages } from '../../../../layouts/mobileScreens/messages';
import type { LayoutComponentScreen } from '../../../../layouts/types';
import { MobileTabBarWrapper, TabBarLink } from './styles';

interface MobileTabBarProps {
  items: LayoutComponentScreen[];
}
export const MobileTabBar = ({ items }: MobileTabBarProps) => {
  const { recentOrdersObs } = useWLOrdersProvider();
  const incompleteOrders = useObservableValue(
    () => recentOrdersObs.pipe(map(orders => orders.filter(o => !isOrderComplete(o.OrdStatus)))),
    [recentOrdersObs],
    []
  );
  return (
    <MobileTabBarWrapper background="backgroundHeader" justifyContent="space-around">
      {items.map(item => (
        <TabBarLink data-testid={`tab-bar-${item.path}`} to={item.path} key={item.path} end>
          <VStack
            w="4rem"
            p="spacing8"
            gap="spacing4"
            color="colorTextDefault"
            borderTop="solid 2px"
            borderColor="transparent"
          >
            <IndicatorDotWrapper
              show={item.label === 'Orders' && incompleteOrders.length > 0}
              variant={IndicatorDotVariants.Primary}
            >
              {item.icon && <Icon icon={item.icon} size={24} color="colorTextSubtle" />}
            </IndicatorDotWrapper>
            <Box fontSize="fontSizeTiny" whiteSpace="nowrap">
              {item.label in MobileLabelMessages ? (
                <FormattedMessage {...MobileLabelMessages[item.label as keyof typeof MobileLabelMessages]} />
              ) : (
                item.label
              )}
            </Box>
          </VStack>
        </TabBarLink>
      ))}
    </MobileTabBarWrapper>
  );
};
